const DANGER_CATEGORY_KEYS: Record<string, string> = {
  Low: 'low',
  Moderate: 'moderate',
  High: 'high',
  'Very High': 'veryHigh',
  Severe: 'severe',
  'SPL-I': 'low',
  'SPL-II': 'moderate',
  'SPL-III': 'high',
  'SPL-IV': 'veryHigh',
  'SPL-V': 'extreme',
  'SPL-VI': 'historic',
  'FBP-I': 'low',
  'FBP-II': 'moderate',
  'FBP-III': 'high',
  'FBP-IV': 'veryHigh',
  'FBP-V': 'extreme'
}

export function dangerCategoryKey(name: string | null | undefined): string {
  return `domain.enums.dangerCategory.${DANGER_CATEGORY_KEYS[name ?? ''] ?? 'unknown'}`
}
